export function renderLinePlanningPanel(containerEl) {
  containerEl.innerHTML = `
    <div class="lp-da" style="margin-bottom:6px;">
      <div class="lp-da-row">
        <div class="lp-da-label">Mode</div>
        <select id="lp-mode">
          <option value="manual" selected>Manual</option>
          <option value="depth">Depth Aware</option>
        </select>
      </div>
    </div>

    <div id="lp-depthaware-row" class="lp-da lp-collapse" aria-hidden="true">
      <div class="lp-da-row">
        <div class="lp-da-label">Depth source</div>
        <select id="dap-source">
          <option value="etopo">ETOPO (ArcGIS)</option>
          <option value="gebco">GEBCO (ArcGIS)</option>
        </select>
      </div>

      <div class="lp-da-row">
        <div class="lp-da-label">Opening swath angle</div>
        <div class="lp-da-control">
          <div class="lp-da-box">
            <input id="dap-angle" type="number" value="140" min="10" max="179" step="1">
          </div>
          <span class="muted lp-unit">&deg;</span>
        </div>
      </div>

      <div class="lp-da-row">
        <div class="lp-da-label">Overlap</div>
        <div class="lp-da-control">
          <div class="lp-da-box">
            <input id="dap-overlap" type="number" value="20" min="0" max="90" step="1">
          </div>
          <span class="muted lp-unit">%</span>
        </div>
      </div>

      <div class="muted lp-da-status" id="dap-status">idle</div>
    </div>

    <div class="row lp-actions" style="gap:8px;flex-wrap:wrap;align-items:center;margin-top:8px;">
      <button id="lp-draw" class="secondary btn">Draw AOI</button>
      <button id="lp-generate" class="secondary btn">Generate lines</button>
      <button id="lp-save" class="secondary btn" disabled>Save</button>
      <button id="lp-clear" class="secondary btn">Clear</button>
      <span class="muted" id="lp-status" style="margin-left:auto;">ready</span>
    </div>

    <div class="lp-rnglist" style="margin-top:10px;">
      <div class="lp-rng-row">
        <div class="lp-rng-label">Rotation</div>
        <input id="lp-heading" type="number" value="0" min="0" max="359" step="1" class="lp-num">
        <input id="lp-heading-slider" type="range" min="0" max="359" step="1" value="0" class="lp-slider">
      </div>

      <div id="lp-spacing-wrap" class="lp-rng-row">
        <div class="lp-rng-label">Spacing</div>
        <input id="lp-spacing" type="number" value="50" min="1" step="1" class="lp-num">
        <input id="lp-spacing-slider" type="range" min="1" max="500" step="1" value="50" class="lp-slider">
      </div>

      <div id="lp-extend-wrap" class="lp-rng-row">
        <div class="lp-rng-label">Extension</div>
        <input id="lp-extend" type="number" value="0" min="0" step="10" class="lp-num">
        <span class="muted" style="font-size:11px;opacity:.85;">m (next generate)</span>
      </div>

      <div id="lp-prefix-wrap" class="lp-rng-row">
        <div class="lp-rng-label">Label prefix</div>
        <input id="lp-prefix" type="text" value="L" class="lp-num">
      </div>

      <div id="lp-start-wrap" class="lp-rng-row">
        <div class="lp-rng-label">Start #</div>
        <input id="lp-start" type="number" value="1" min="1" step="1" class="lp-num">
      </div>

      <div id="lp-speed-wrap" class="lp-rng-row">
        <div class="lp-rng-label">Vessel speed</div>
        <input id="lp-vessel-speed" type="number" value="8" min="0.1" step="0.1" class="lp-num">
        <span class="muted" style="font-size:11px;opacity:.85;">kt</span>
      </div>
    </div>

    <div class="muted" id="lp-count" style="text-align:right;font-size:11px;opacity:.85;">0 lines</div>
    <hr class="subtle-hr" />

    <div class="row" style="gap:8px;flex-wrap:wrap;align-items:center;margin-top:6px;">
      <select id="lp-export-format" class="lp-export-format" aria-label="Export format">
        <option value="geojson" selected>GeoJSON</option>
        <option value="lnw">HYPACK LNW</option>
        <option value="dxf">AutoCAD DXF</option>
        <option value="gpx">GPX (Chart Plotter)</option>
      </select>
      <button id="lp-export-selected" class="secondary btn" disabled>Export selected</button>
    </div>

    <div class="field" style="margin-top:10px;">
      <label>Saved line plans</label>
      <div id="lp-planlist" class="muted" style="font-size:12px;line-height:1.35;">
        (none yet)
      </div>
    </div>

    <hr class="subtle-hr" style="margin-top:14px;" />

    <div class="field" style="margin-top:10px;">
      <label style="font-weight:700;font-size:12px;color:var(--fg);letter-spacing:0.03em;">Statistical LNM Estimator</label>
      <div class="muted" style="font-size:10px;margin-top:2px;margin-bottom:8px;">
        Draw AOI polygons — ETopo depth is auto-sampled and LNM estimated via sqrt(area) method.
      </div>

      <div class="lp-rnglist">
        <div class="lp-rng-row">
          <div class="lp-rng-label">Sector coverage</div>
          <input id="lp-stat-coverage" type="number" value="4" min="1" max="20" step="0.5" class="lp-num">
          <span class="muted" style="font-size:11px;opacity:.85;">× WD</span>
        </div>
        <div class="lp-rng-row">
          <div class="lp-rng-label">Crossline</div>
          <input id="lp-stat-crossline" type="number" value="4" min="0" max="100" step="1" class="lp-num">
          <span class="muted" style="font-size:11px;opacity:.85;">%</span>
        </div>
        <div class="lp-rng-row">
          <div class="lp-rng-label">Shoal contingency</div>
          <input id="lp-stat-shoal" type="number" value="0" min="0" max="100" step="1" class="lp-num">
          <span class="muted" style="font-size:11px;opacity:.85;">%</span>
        </div>
        <div class="lp-rng-row">
          <div class="lp-rng-label">Run-in buffer</div>
          <input id="lp-stat-runin" type="number" value="200" min="0" max="2000" step="50" class="lp-num">
          <span class="muted" style="font-size:11px;opacity:.85;">m</span>
        </div>
        <div class="lp-rng-row">
          <div class="lp-rng-label">Depth source</div>
          <select id="lp-stat-source">
            <option value="etopo">ETOPO (NGDC)</option>
            <option value="gebco">GEBCO (ArcGIS)</option>
          </select>
        </div>
      </div>

      <div class="row" style="gap:8px;flex-wrap:wrap;align-items:center;margin-top:8px;">
        <button id="lp-stat-draw" class="secondary btn">Draw AOI</button>
        <button id="lp-stat-clear-all" class="secondary btn">Clear all</button>
        <span id="lp-stat-status" class="muted" style="font-size:11px;margin-left:auto;">Ready</span>
      </div>

      <div id="lp-stat-table" style="margin-top:8px;overflow-x:auto;font-size:11px;"></div>
    </div>
  `;
}

